import * as STD                            from '@emersya/mpa-std-lib';
// import * as BasketNS                       from '@libs/MPAApplication/Basket';
import CM                                      from '@emersya/mpa-components-manager-lib';
import { Field, InputSelect }           from '@emersya/mpa-components-lib';
// import { Field, Image, InputSelect }           from '@emersya/mpa-components-lib';
import manifestXMLSource                       from './StandingPersonalizationEditor.xml';
import './StandingPersonalizationEditor.scss';
// import { NS as StandingPersonalizationTileNS } from '../StandingPersonalizationTile/StandingPersonalizationTile';

export interface IStandingPersonalizationEditorComponentConfiguration extends Field.Configuration {
};

export class StandingPersonalizationEditorComponent extends Field.Component {

	private async updateOptions(event : STD.events.Event<any, CM.Component<any, any>>) {
		if (!app.basket || !app.currentProduct || !app.currentProduct.reference) {
			this.component_throwLibraryError('');
		}
		const personalizationPart = app.currentProduct.getPart([ 'personalization' ]);
		personalizationPart.options.length = 0;
		personalizationPart.currentOption = null;
		// TODO : And of course, add current options.
		const inputSelect = <InputSelect.Component> this.component_find('@:content.options');
		for (const c of Array.from(inputSelect.component_outerChilds)) {
			await c.component_delete();
		}
		for (const fakeTitle of inputSelect.component_querySelectorAll('.fake-title')) {
			fakeTitle.remove();
		}
		const updatedProduct = app.basket?.basket.currentProduct?.sku?.value;
		if (!updatedProduct) {
			throw STD.errors.user('error while loading new sku product from basket');
		}
		const component = app.component_configuration.productsComponents.find(x => x.type === 'personalization');
		if (!component) {
			throw STD.errors.user('No component with type personalization');
		}
		const relatedOptions = app.component_configuration.productsOptions.filter(x => x.component ===
			component.SKU &&
			x.products.find(y => y === updatedProduct));


		await app.fillComponentOptions(
			this,
			personalizationPart,
			inputSelect,
			relatedOptions,
			'standing-personalization-tile',
			event
		);

		/*
				const includedOptions = relatedOptions.filter(x => !x.price ||
					!(<any> x.price[ app.currentCurrency.id ]).price ||
					!(<any> x.price[ app.currentCurrency.id ]).price.inclTax);
				const inOptionOptions = relatedOptions.filter(x => !includedOptions.includes(x));
				const x2f = async (opts : typeof relatedOptions) => {
					for (const optionDescriptor of opts) {
						const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
							a[ c ] = optionDescriptor.SKU;
							return a;
						}, {});
						const translations = optionDescriptor.translations[ '@name' ];
						if (!translations) {
							this.component_throwUserError('Missing trad @name for floor option : ' + optionDescriptor.SKU);
						}
						const currentTrad = translations[ app.currentLanguage ];
						if (!currentTrad) {
							this.component_throwUserError('Missing trad @name for floor option :' +
								optionDescriptor.SKU +
								' for language ' +
								app.currentLanguage);
						}
						const price = optionDescriptor?.price?.[ app.currentCurrency.id ]?.price;
						personalizationPart.createOption({
							id :            optionDescriptor.SKU,
							title :         currentTrad,
							reference :     { value : optionDescriptor.SKU },
							components :    [],
							metaData :      <any> {
								viewerGroups : optionDescriptor.viewerGroups,
								translations : translations,
								SKU :          optionDescriptor.additionalData?.SKU,
								RGB :          optionDescriptor.additionalData?.RGB
							},
							price :         (<any> price || null),
							taxes :         [],
							technicalFees : null
						});
						const tile = <StandingPersonalizationTileNS.Component> await inputSelect.component_instantiateOuterChild<StandingPersonalizationTileNS.Configuration>(
							{
								type :          'standing-personalization-tile',
								id :            optionDescriptor.SKU,
								tree :          this.component_tree,
								slot :          null,
								isSlot :        false,
								declaredSlot :  null,
								configuration : {
									SKU :                    optionDescriptor.SKU,
									component :              optionDescriptor.component,
									'@innerConfigurations' : {
										'image' : <Image.Configuration> {
											'@translations' : {
												'name' : tr
											},
											'URL' :           optionDescriptor.iconURL
										}
									},
									'@translations' :        {
										text : STD.translationsManager.languages.reduce<STD.translationsManager.TranslationMapping>((a, c) => {
											a[ c ] =
												`${ (<STD.translationsManager.TranslationMapping> optionDescriptor.translations[ '@name' ])[ c ] } (${ optionDescriptor.additionalData?.SKU })`;
											return a;
										}, {})
									}
								}
							}
						);
						await tile.component_initialize();
						await tile.component_start(event);
					}
				};
				this.component_defineTranslation('included', (<any> this.component_configuration[ '@translations' ]).included, true);
				this.component_defineTranslation('optional', (<any> this.component_configuration[ '@translations' ]).optional, true);
				inputSelect.component_DOM.appendChild(STD.DOM.factory({
					tag :       'h3',
					classList : [ 'fake-title' ],
					dataset :   {
						translation : <string> this.component_generateTranslationId('included')
					},
					style :     {
						marginRight : '100%'
					}
				}));
				await x2f(includedOptions);
				inputSelect.component_DOM.appendChild(STD.DOM.factory({
					tag :       'h3',
					classList : [ 'fake-title' ],
					dataset :   {
						translation : <string> this.component_generateTranslationId('optional')
					},
					style :     {
						marginRight : '100%',
						whiteSpace :  'nowrap'
					}
				}));
				await x2f(inOptionOptions);
				*/
		STD.translationsManager.update(this.component_DOM);
		return true;
	};

	async reset(event : STD.events.Event<any, CM.Component<any, any>>) {
		const isForThisProduct = await this.updateOptions(event);
		if (!isForThisProduct) {
			return;
		}
		const defaultSKU = app.currentDefaults.personalization;
		if (defaultSKU) {
			const select = <InputSelect.Component> this.component_find('@:content.options');
			await select.updateValueFromId(defaultSKU);
		}
	};

	override async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.onValueUpdated(ev);
		const select = <InputSelect.Component> this.component_find('@:content.options');
		const option = select.value;
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const part = app.basket.basket.currentProduct.getPart([ 'personalization' ]);
		if (!option) {
			if (part.currentOption) {
				await part.unuseOption();
			}
		} else {
			if (part.currentOption && part.currentOption.id === option.id) {
				return;
			}
			await part.useOption(option.id);
		}
	};

	override async component_initialize() {
		await this.component_find('@:content').component_instantiateOuterChild({
			type :          'input-select',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : {}
		});
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		for (const product of app.basket.basket.products) {
			const part = product.createPart({
				id :        'personalization',
				title :     'Personalization',
				reference : null,
				metaData :  null,
				parts :     [],
				options :   []
			});
			await part.initialize();
		}
	};

	get productComponent() {
		const PC = app.component_configuration.productsComponents.find(x => x.type === 'personalization');
		if (!PC) {
			throw STD.errors.user('No product component with type personalization!');
		}
		return PC;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPersonalizationEditorComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingPersonalizationEditorComponent;
	export type Component = StandingPersonalizationEditorComponent;
	export type Configuration = IStandingPersonalizationEditorComponentConfiguration;
}

CM.declare({
	id :       'standing-personalizationEditor',
	type :     StandingPersonalizationEditorComponent,
	manifest : manifestXMLSource
});
